import React from 'react';

export const AutomotiveIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.08 3.11H5.77L6.85 7zM7.5 16c-.83 0-1.5-.67-1.5-1.5S6.67 13 7.5 13s1.5.67 1.5 1.5S8.33 16 7.5 16zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
  </svg>
);

export const ChemicalIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M19.66 17.22l-6-10.39V3h2V1H8v2h2v3.83l-6 10.39C3.33 18.39 4.3 21 7 21h10c2.7 0 3.67-2.61 2.66-3.78zM7 19c-1.12 0-1.74-.75-1.48-1.52L9 11h6l3.48 6.48c.26.77-.36 1.52-1.48 1.52H7z"/>
  </svg>
);

export const PowerEnergyIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M12.75 2h-1.5l-1 5H6v2h3.58l-.6 3H5v2h3.58l-1.6 8h2.04l1.4-7h3.16l1.4 7h2.04l-1.6-8H19v-2h-3.98l-.6-3H18V7h-4.25l-1-5zm-1 7h4.5l-.6 3h-3.3l-.6-3z"/>
  </svg>
);

export const ManufacturingIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M22 10v12H2V10l7-3v2l5-2v3h8zm-10-3.5V2h-3v4.5L9 6v6l5-2v-3.5zM12 18h2v2h-2v-2zm-4 0h2v2H8v-2zm-4 0h2v2H4v-2zm12 0h2v2h-2v-2z"/>
  </svg>
);

export const ITIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12zm-3.5-3.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM19 8h-3v3h3V8zm-5 4h-3v-3h3v3z"/>
  </svg>
);

export const HealthcareIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35zm-2-9.35l1.5-4 2 8 1.5-4h2.5v-2h-1.5l-1.5 4-2-8-1.5 4H8v2h2z"/>
  </svg>
);

export const EducationIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zm6.83 7.91L12 14.65l-6.83-3.74L12 7.18l6.83 3.73zM5 13.18v4.18c0 .87 3.13 2.64 7 2.64s7-1.77 7-2.64v-4.18l-7 3.82-7-3.82z"/>
  </svg>
);

export const GovtIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L1 7v2h22V7L12 2zm-7 9h2v7H5v-7zm6 0h2v7h-2v-7zm6 0h2v7h-2v-7zM3 18v2h18v-2H3z"/>
  </svg>
);
